import dayjs from 'dayjs';

export interface IRegisterProspectRequest {
  client_id: string;
  advisor_id: string;
}

export interface IRegisterProspectResponse {
  client_id: string;
  advisor_id: string;
  is_prospect: boolean;
  created_at: dayjs.ConfigType;
  updated_at: dayjs.ConfigType;
}

export interface ISyncClientDataRequest {
  client_id: string;
  advisor_id: string;
}

export enum InteractionSubSectionType {
  'home_page' = 'home_page',
  'record_page' = 'record_page',
  'risk_assessment' = 'risk_assessment',
  'personal_details' = 'personal_details',
  'financial_goals' = 'financial_goals',
  'income_details' = 'income_details',
  'expenditure_details' = 'expenditure_details',
  'asset_details' = 'asset_details',
  'liabilities_details' = 'liabilities_details',
  'medical_information' = 'medical_information',
  'benefits_and_insurance' = 'benefits_and_insurance',
  'investment_experience' = 'investment_experience',
  'beneficiary_details' = 'beneficiary_details',
  'client_summary' = 'client_summary',
}

export interface ISyncClientDataResponse {
  client_id: string;
  sections: InteractionSubSectionType[];
}

export enum InteractionchatType {
  'fact_find' = 'fact_find',
  'financial_planning' = 'financial_planning',
  'plans' = 'plans',
}

export enum IFactFindProcessSectionType {
  personal_details = 'personal_details',
  income = 'income',
  health_condition = 'health_condition',
  liabilities = 'liabilities',
  assets = 'assets',
  expenditure = 'expenditure',
}

export enum IFactFindProcessStatus {
  pending = 'pending',
  started = 'started',
  completed = 'completed',
  failed = 'failed',
}
export interface IFactfindProcessConfig {
  section_name: string;
  status: IFactFindProcessStatus;
  summary_id: string;
  created_at: dayjs.ConfigType;
  updated_at: dayjs.ConfigType;
}

export interface IChatRequest {
  message: string;
  session_id?: string;
  chat_type: InteractionchatType;
  client_id: string;
  advisor_id: string;
  stream?: boolean;
  record?: boolean;
}

export interface IMarkChatRequest2 {
  session_id: string;
  client_id: string;
  index: number;
}

export interface ISessionsChatResponse {
  session_id: string;
  client_id: string;
  advisor_id: string;
  chat_session: [];
  processed_offset: 0;
  chat_type: string;
  chat_name: string;
  created_at: dayjs.ConfigType;
  updated_at: dayjs.ConfigType;
}

export interface IPatchAIInteractionSectionRequest {
  section: InteractionSubSectionType;
  data: object;
  client_id: string;
}

export interface IViewClientDataSummaryResponse {
  income: {
    currency: string;
    total_client_income: number;
    total_partner_income: number;
    total_joint_income: number;
    total_monthly_income: number;
    total_annual_income: number;
  };
  expenditure: {
    currency: string;
    total_client_expenditure: number;
    total_partner_expenditure: number;
    total_joint_expenditure: number;
    total_monthly_expenditure: number;
    total_annual_expenditure: number;
  };
  assets_and_liabilities: {
    currency: string;
    all: {
      assetAmount: number;
      liabilityAmount: number;
      netAmount: number;
    };
    client: {
      name: string;
      assetAmount: number;
      liabilityAmount: number;
      netAmount: number;
      assetDetails: {
        assetAmount: number;
        assetCurrency: string;
        assetType: string;
      }[];
    };
    partner: {
      assetAmount: number;
      liabilityAmount: number;
      netAmount: number;
      assetDetails: {
        assetAmount: number;
        assetCurrency: string;
        assetType: string;
      }[];
    };
    joint: {
      assetAmount: number;
      liabilityAmount: number;
      netAmount: number;
      assetDetails: {
        assetAmount: number;
        assetCurrency: string;
        assetType: string;
      }[];
    };
  };
}

export interface IMarkChatRequest {
  session_id: string;
  index: number;
}

export interface IMarkChatRequest2 {
  session_id: string;
  client_id: string;
  index: number;
}

export interface IStartNewChatRequest {
  chat_type: string;
  client_id: string;
  advisor_id: string;
  message: string;
  session_id?: string;
}

export interface IMergeClientDataRequest {
  clientId: string;
  acceptedAuditId: string;
  rejectedAuditId: string;
}

export interface IStartNewChatResponse {
  session_id: string;
  message: [];
}

export interface IProcessTrackerResponse {
  processed_data: null;
  process_type: string;
  process_id: string;
  created_at: dayjs.ConfigType;
  completed_at: dayjs.ConfigType;
  client_id: string;
  requested_data: {
    sections: [];
  };
  updated_at: dayjs.ConfigType;
}

export interface IViewTrackProgressRequest {
  document_id: string;
}

export enum ITrackProgressStatus {
  'IN_PROGRESS' = 'IN_PROGRESS',
  'COMPLETED' = 'COMPLETED',
  'FAILED' = 'FAILED',
}
export interface IViewTrackProgressResponse {
  updated_at: dayjs.ConfigType;
  transcript_id: string;
  id: string;
  file_path: string;
  created_at: dayjs.ConfigType;
  advisor_id: string;
  status: ITrackProgressStatus;
  file_type: 'Transcript';
}

export interface IRemoveGoalRequest {
  client_id: string;
  goal_id: string;
}

export interface IReportsAvailabilityResponse {
  background_tasks_running: boolean;
  delta_messages: boolean;
  latest_summary: {
    session_id: string;
    chat_summary: string;
    created_at: string;
    process_doc_id: string | null;
    is_final: boolean;
    discarded: boolean;
    version: number;
    updated_at: string;
    message_timestamp: string | null;
    client_id: string;
    chunk_index: number | null;
    comment: string;
    meta_data: {
      source: string;
    };
  };
}
